import pos from "@/services/poscrm";
import util from "./util";

export default {
 createPayment(data) {
  pos({
   url: "/api/v1.1/" + data[0].uid + "/Payment/create",
   data: data,
   method: "post",
  }).then((res) => {
   console.log(res.data);

   let paymentdata = {};

   if (res.data.error.code === 0) {
    paymentdata = {
     payReceiptAt: new Date(),
     paymentId: data[0].id,
     payment: {
      id: data[0].id,
      objectId: data[0].objectId,
      paid: data[0].paid,
      change: data[0].change,
     },
    };
   } else {
    paymentdata = null;
   }

   return paymentdata;
  });
 },

 paymentDefault(data) {
  let datetime = new Date();
  let objectId = util.createObjectId();
  let id = util.createObjectId();

  return [
   {
    objectId: objectId,
    id: id,
    change: data.change,
    created_at: datetime,
    created_by: {
     username: "Admin",
     id: "User001",
    },
    created_by_id: "User001",
    paid: data.paid,
    payAt: datetime,
    paymentItems: data.paymentItems,
    paymentStatus: data.paymentStatus,
    pos: {
     id: "",
     posNumber: "001",
     objectId: "",
    },
    posId: "",
    shop: {
     id: data.shop.id,
     objectId: data.shop.objectId,
     branchName: data.shop.branchName,
    },
    shopId: data.shopId,
    uid: data.uid,
    updated_at: datetime,
    updated_by: {
     id: "User001",
     username: "Admin",
    },
    updated_by_id: "User001",
   },
  ];
 },
 // ===== NEW: KBANK payload builder (matches your sample body) =====
 PaymentKBANKDefault(receipt, opts = { paymentCode: "333", type: "qr" }) {
  const user = {
   id: "User001",
   username: "Admin",
  };

  // KBANK uses type code 11 for QR (per sample)
  const KBANK_QR_TYPE = 12;

  // Generate IDs if absent
  const paymentId = receipt.payment?.id || '';
  const paymentObjectId = receipt.payment?.objectId || '';

  const nowIso = new Date().toISOString();

  const payment = {
   updated_by_id: user.id,
   change: receipt.payment?.change ?? 0,
   shopId: receipt.shopId,
   created_by: { ...user },
   balanceAfterDeposit: 0,
   uid: receipt.uid,
   shop: {
    objectId: receipt.shop?.objectId,
    branchName: receipt.shop?.branchName,
    id: receipt.shop?.id || receipt.shopId,
   },
   pos: {
    posNumber: receipt.pos?.posNumber || "001",
    objectId: receipt.pos?.objectId || util.createObjectId(),
    id: receipt.pos?.id || receipt.posId || util.createObjectId(),
   },
   posId: receipt.posId || receipt.pos?.id || util.createObjectId(),
   paymentStatus: "P",
   objectId: paymentObjectId,
   payAt: nowIso,
   paid: receipt.grandTotal, // pay full grand total
   created_by_id: user.id,
   id: paymentId,
   types: [KBANK_QR_TYPE],
   updated_at: nowIso,
   paymentItems: [
    {
     sequene: 0,
     cashDeposit: 0,
     amount: receipt.grandTotal,
     updated_at: nowIso,
     created_by: { ...user },
     id: util.createObjectId(),
     inputAmount: receipt.grandTotal,
     paymentType: KBANK_QR_TYPE,
     updated_by: { ...user },
     updated_by_id: user.id,
     created_at: nowIso,
     created_by_id: user.id,
    },
   ],
   updated_by: { ...user },
   created_at: nowIso,
  };

  const finalReceipt = {
   ...receipt,
   paymentId,
   payment: {
    paid: receipt.grandTotal,
    change: receipt.payment?.change ?? 0,
    objectId: paymentObjectId,
    id: paymentId,
   },
   netAmountIncVAT: receipt.netAmountIncVAT ?? receipt.grandTotal,
   netTotalIncVAT: receipt.netTotalIncVAT ?? receipt.grandTotal,
   isVATIncluded: receipt.isVATIncluded ?? true,
   updated_at: nowIso,
   created_at: receipt.created_at || nowIso,
   receiptStatus: "P",
  };

  const body = {
  //  paymentCode: opts.paymentCode,
   type: opts.type, // 'qr'
   payment,
   receipt: finalReceipt,
  };

  return body;
 },
 PaymentGHLDefault(type, receipt) {
  const user = {
   id: "User001",
   username: "Admin",
  };

  const paymentId = receipt.payment?.id || "";
  const paymentObjectId = receipt.payment?.objectId || "";

  const paymentItem = {
   paymentType: 16,
   amount: receipt.grandTotal,
   inputAmount: receipt.grandTotal,
   objectId: util.createObjectId(),
   id: util.createObjectId(),
   KBankQRSubPaymentType: type,
   subTypeName: util.getGHLMethodNameByType(type),
  };

  const payment = {
   objectId: paymentObjectId,
   id: paymentId,
   paid: receipt.payment?.paid || 0,
   change: receipt.payment?.change || 0,
   created_by: user,
   created_by_id: user.id,
   updated_by: user,
   updated_by_id: user.id,
   uid: receipt.uid,
   shopId: receipt.shopId,
   shop: receipt.shop,
   posId: receipt.posId,
   pos: receipt.pos || {},
   paymentItems: [paymentItem],
   types: [type],
   paymentStatus: "P",
   receipt: {
    objectId: receipt.objectId,
    id: receipt.id,
    orderNo: receipt.orderNo,
    netAmount: receipt.netAmount,
    netTotal: receipt.netTotal,
    // queueIndex: receipt.queueIndex,
    grandTotal: receipt.grandTotal,
   },
   dateString: new Date(receipt.created_at).toISOString().slice(0, 10),
  };

  // Attach payment info inside receipt too
  const finalReceipt = {
   ...receipt,
   created_by: user,
   created_by_id: user.id,
   receiptBy: user,
   receiptById: user.id,
   paymentId: paymentId,
   payment: {
    ...receipt.payment,
    objectId: paymentObjectId,
    id: paymentId,
   },
   pos: receipt.pos || {},
   posId: receipt.posId,
   dateString: new Date(receipt.created_at).toISOString().slice(0, 10),
  };

  return {
   type: type,
   payment,
   receipt: finalReceipt,
  };
 },
 
 PaymentGHLDefault(type, receipt) {
  const user = {
   id: "User001",
   username: "Admin",
  };

  const paymentId = receipt.payment?.id || "";
  const paymentObjectId = receipt.payment?.objectId || "";

  const paymentItem = {
   paymentType: 16,
   amount: receipt.grandTotal,
   inputAmount: receipt.grandTotal,
   objectId: util.createObjectId(),
   id: util.createObjectId(),
   KBankQRSubPaymentType: type,
   subTypeName: util.getGHLMethodNameByType(type),
  };

  const payment = {
   objectId: paymentObjectId,
   id: paymentId,
   paid: receipt.payment?.paid || 0,
   change: receipt.payment?.change || 0,
   created_by: user,
   created_by_id: user.id,
   updated_by: user,
   updated_by_id: user.id,
   uid: receipt.uid,
   shopId: receipt.shopId,
   shop: receipt.shop,
   posId: receipt.posId,
   pos: receipt.pos || {},
   paymentItems: [paymentItem],
   types: [type],
   paymentStatus: "P",
   receipt: {
    objectId: receipt.objectId,
    id: receipt.id,
    orderNo: receipt.orderNo,
    netAmount: receipt.netAmount,
    netTotal: receipt.netTotal,
    // queueIndex: receipt.queueIndex,
    grandTotal: receipt.grandTotal,
   },
   dateString: new Date(receipt.created_at).toISOString().slice(0, 10),
  };

  // Attach payment info inside receipt too
  const finalReceipt = {
   ...receipt,
   created_by: user,
   created_by_id: user.id,
   receiptBy: user,
   receiptById: user.id,
   paymentId: paymentId,
   payment: {
    ...receipt.payment,
    objectId: paymentObjectId,
    id: paymentId,
   },
   pos: receipt.pos || {},
   posId: receipt.posId,
   dateString: new Date(receipt.created_at).toISOString().slice(0, 10),
  };

  return {
   type: type,
   payment,
   receipt: finalReceipt,
  };
 },

 buildPaymentPayload(gateway, type, receipt, opts) {
  console.log(type);
  
  const gw = (gateway || 'GHL').toUpperCase()
  if (gw === 'KBANK') return this.PaymentKBANKDefault(receipt, { paymentCode: '333', type: type, ...(opts || {}) })
  return this.PaymentGHLDefault(type, receipt)
  },
};
